const images = [
  {
    thumb: require("../../../assets/collection/styled/dab_ostoja_spokoju.jpg"),
    src: require("../../../assets/collection/styled/dab_ostoja_spokoju.jpg"),
    caption: "Ostoja spokoju",
    srcset: require("../../../assets/collection/styled/dab_ostoja_spokoju.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/styled/dab_sloneczny_brzeg.jpg"),
    src: require("../../../assets/collection/styled/dab_sloneczny_brzeg.jpg"),
    caption: "Dąb słoneczny brzeg",
    srcset: require("../../../assets/collection/styled/dab_sloneczny_brzeg.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/styled/natura_2000.jpg"),
    src: require("../../../assets/collection/styled/natura_2000.jpg"),
    caption: "Natura 2000",
    srcset: require("../../../assets/collection/styled/natura_2000.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/styled/ostoja_spokoju_i.jpg"),
    src: require("../../../assets/collection/styled/ostoja_spokoju_i.jpg"),
    caption: "Ostoja spokoju I",
    srcset: require("../../../assets/collection/styled/ostoja_spokoju_i.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/styled/ostoja_spokoju_ii.jpg"),
    src: require("../../../assets/collection/styled/ostoja_spokoju_ii.jpg"),
    caption: "Ostoja spokoju II",
    srcset: require("../../../assets/collection/styled/ostoja_spokoju_ii.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/styled/primario.jpg"),
    src: require("../../../assets/collection/styled/primario.jpg"),
    caption: "Primario",
    srcset: require("../../../assets/collection/styled/primario.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/styled/sloneczny_brzeg.jpg"),
    src: require("../../../assets/collection/styled/sloneczny_brzeg.jpg"),
    caption: "Słoneczny brzeg",
    srcset: require("../../../assets/collection/styled/sloneczny_brzeg.jpg"),
    description: ""
  }
];

export default images;
